//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

//local imports
import { Transforms } from '@app/shared';
import { AbstractProgramModel } from '@app/catalog-common';

@Component({
    selector: 'program-selection-list',
    templateUrl: './program-selection-list.component.html',
    styleUrl: './program-selection-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramSelectionListComponent {

    public programs = input.required<AbstractProgramModel[]>();
    public id = input.required<string>();
    public formGroup = input.required<FormGroup>();
    public label = input<string>("Program");
    public required = input(false, {
        transform: Transforms.toBoolean
      });
      
    constructor() { }    
}
